<template>
    <v-card tile>
        <v-card-title>Datenschutzhinweis</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <p>
                Der Schutz Ihrer personenbezogenen Daten wird bei der Nutzung dieser Webseiten sehr ernst genommen.
                Nachfolgend werden Sie über die Erhebung, die Verarbeitung und die Nutzung Ihrer personenbezogenen Daten
                informiert, wenn Sie diese Webseiten besuchen und die dort angebotenen Services und Dienstleistungen
                nutzen.
            </p>
            <ol>
                <li><b>Information zu personenbezogenen Daten</b><br>
                    Personenbezogene Daten sind solche Einzelangaben, die sich auf eine Person beziehen oder die
                    geeignet sind, einen Bezug zu einer Person herzustellen, wie z. B. der Name, die Postadresse, eine
                    Telefonnummer, eine E-Mail-Adresse, die Bankverbindung, ggf. aber auch Nutzungsdaten wie Ihre
                    IP-Adresse etc. Durch personenbezogene Daten kann unter Umständen somit auf die Identität einer
                    Person rückgeschlossen werden.
                </li>
                <li>
                    <b>Verantwortliche Stelle</b><br>
                    Der Ellerauer Tennis Club an der Krumbek. e. V. ist Verantwortliche Stelle im Sinne des
                    Datenschutzrechtes.<br> Die Kontaktdaten lauten:<br></br>

                    Ellerauer Tennis Club an der Krumbek e. V.</br>
                    Königsberger Str. 16</br>
                    25479 Ellerau</br></br>

                    Telefon: 04106/71301</br>
                    Telefax: 04106/75980</br>
                    E-Mail: <a href="mailto:etc.krumbek@etc-ellerau.de">etc.krumbek@etc-ellerau.de</a></br>
                </li>
                <li><b>Rechte auf Auskunft, Berichtigung, Löschung, Übertragbarkeit, Widerruf, Beschwerde </b><br>
                    <ol>
                        <li>Sie haben das Recht, von uns jederzeit Auskunft zu verlangen über die zu Ihnen bei uns
                            gespeicherten Daten, sowie zu deren Herkunft, den Empfängern oder Kategorien von Empfängern,
                            an die diese Daten weitergegeben werden und den Zweck der Speicherung.
                        </li>
                        <li>Sie haben das Recht auf Berichtigung unrichtiger Sie betreffender Daten sowie unter den
                            jeweiligen Voraussetzungen gemäß Datenschutzgrundverordnung das Recht auf Löschung oder
                            Einschränkung der Verarbeitung der Sie betreffender Daten bzw. Sie können die Verarbeitung
                            widersprechen, z. B. aus Gründen, die sich aus Ihrer besonderen Situation ergeben.
                        </li>
                        <li>Sie haben das Recht auf Datenübertragbarkeit, d. h. das Recht, die Sie betreffenden
                            personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen
                            und maschinenlesbaren Format zu erhalten.
                        </li>
                        <li>Wenn Sie eine Einwilligung zur Nutzung von Daten erteilt haben, können Sie diese jederzeit
                            widerrufen. Die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten
                            Verarbeitung wird durch den Widerruf nicht berührt.
                        <li>Sie haben das Recht sich jederzeit bei der zuständigen Datenschutzbehörde Ihres Bundeslandes
                            zu beschweren.
                        </li>
                        <li>Alle Informationswünsche, Auskunftsanfragen oder Widersprüche zur Datenverarbeitung richten
                            Sie bitte per E-Mail an die <a href="mailto:gs@etc-ellerau.de">Geschäftsstelle</a> oder an
                            die unter Punkt 2 genannte Adresse.
                        </li>
                    </ol>
                </li>
                <li>
                    <b>Automatisierte Entscheidungsfindung</b><br>
                    Eine automatisierte Entscheidungsfindung wird hier nicht angewandt.
                </li>
                <li>
                    <b>Speicherung von Zugriffsdaten beim Besuch dieser Website</b><br>
                    <ol>
                        <li>Bei jedem Zugriff auf unseren Internetauftritt werden Zugriffsdaten in einer Protokolldatei
                            auf dem Server unseres Providers gespeichert.
                        </li>
                        <li>Dieser Datensatz besteht z. B. aus Ihrer IP-Adresse, Datum und Uhrzeit der Anforderung, dem
                            Namen der angeforderten Datei, der übertragenen Dateimenge und dem Zugriffsstatus, einer
                            Beschreibung des verwendeten Webbrowsers und Betriebssystems sowie dem Namen Ihres Internet
                            Service Providers.
                        </li>
                        <li>Diese Daten werden aus technischen Gründen erhoben. Eine Auswertung findet ausschließlich zu
                            statistischen Zwecken ohne Personenbezug (Besucherzahlen und Seitenpopularität) statt.
                        </li>
                    </ol>
                </li>
                <li>
                    <b>Erhebung personenbezogener Daten bei informatorischer Nutzung</b><br>
                    Bei der bloß informatorischen Nutzung der Website erheben wir keine personenbezogenen Daten, mit
                    Ausnahme der unter 5.2 erwähnten Daten, die Ihr Browser übermittelt, um Ihnen den Besuch der Website
                    technisch zu ermöglichen.
                </li>
                <li>
                    <b>Hinweis auf mangelnde Vertraulichkeit bei Internetkommunikation</b><br>
                    Bitte beachten Sie, dass bei der normalen unverschlüsselten Kommunikation über das Internet, (z. B.
                    per E-Mail) keine vollständige Vertraulichkeit und Datensicherheit gewährleistet ist. Wir empfehlen
                    daher bei vertraulichen Informationen den Postweg.
                </li>
            </ol>
            <p>
                Über die Verarbeitung personenbezogener Daten durch den ETC im Übrigen informieren wir unter <router-link
                    :to="{name: 'downloads', params: {name: 'datenschutz'}}">Datenschutz</router-link>.
            </p>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        mounted() {
            this.$store.commit('SET_TITLE', 'Datenschutz')
        }
    }
</script>
<style scoped>
    ol {
        counter-reset: item
    }

    li {
        display: block;
        padding-bottom: 5px;
    }

    li:before {
        content: counters(item, ".") ". ";
        counter-increment: item
    }
</style>